const styles = {
  container: {
    maxWidth: '500px',
    margin: '100px auto'
  }
}

export default styles
